module.exports = __webpack_public_path__ + "media/images/shared/icon_todo_black-ee1b822aa9a478909c5e8604cc1148e1.png";